"use client";

/**
 * Marketing landing-page entry point. Picks the mobile or desktop HERO assembly
 * based on the viewport. Rendered by `(public)/page.tsx` for visitors on `/`.
 */
import type { ReactNode } from "react";

import { MarketingPageView } from "@/lib/marketing-analytics/marketing-page-view";
import { useMobileViewport } from "@/lib/use-mobile-viewport";
import { HeroDesktop } from "./hero/hero-desktop";
import { HeroMobile } from "./hero/hero-mobile";
import { H } from "./hero/hero-tokens";
import { WebsiteCustomerChat } from "./website-customer-chat";

export function MarketingHome(): ReactNode {
  const isMobile = useMobileViewport();
  return (
    // Page color beside the 480px mobile column on wide phones / small tablets.
    <div style={{ background: H.page }}>
      <MarketingPageView funnel="website_demo" step={0} />
      <WebsiteCustomerChat />
      {isMobile ? <HeroMobile /> : <HeroDesktop />}
    </div>
  );
}
